import { BrickContext, VisualBrick, registerBrick } from 'olympe';

export default class ClickCapture extends VisualBrick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array<any>} properties
     * @return {Element}
     */
    render($: BrickContext, properties: any[]): Element {
        const el = document.createElement('div');
        el.style.width = '100%';
        el.style.height = '100%';
        el.style.cursor = 'default';
        el.addEventListener('click', (event) => {
            event.stopPropagation();
        });
        return el;
    }
}

registerBrick('01934a0453c8b86a0d0a', ClickCapture);
